<template>
  <v-container id="relatorios-historico" fluid tag="section">
    <v-row justify="center">
      <v-col>
        <usuarios-data-table
          :items="usuarios"
          :userIsAdmin="userIsAdmin"
          :userIsManager="userIsManager"
          title="Usuários"
          @refresh="getUsuarios()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Firestore from '@/Firestore.js';
  import UsuariosService from '@/services/UsuariosService';

  export default {
    name: 'Usuarios',
    components: {
      UsuariosDataTable: () => import('@/components/usuarios/UsuariosDataTable')
    },
    data() {
      return {
        usuarios: []
      };
    },
    computed: {
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      },
      userIsManager() {
        return this.$store.getters.getUserIsManager;
      }
    },
    mounted() {
      this.getUsuarios();
    },
    methods: {
      async getUsuarios() {
        let usuarios = this.userIsAdmin ? await this.getTodosUsuarios() : await this.getUsuariosEmpresa();
        UsuariosService.getUsuariosOnlyUidAndPerfil()
          .then((response) => {
            const listaUsuariosBancoHexa = response.data.data;
            usuarios.forEach((usuario) => {
              const userByUid = listaUsuariosBancoHexa.find((u) => u.uid == usuario.id);
              if (userByUid) {
                usuario.perfil = userByUid.perfil.perfil;
              } else {
                usuario.perfil = '';
              }
            });
            this.usuarios = usuarios;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar usuários.', '', { position: 'topRight' });
          });
      },
      async getTodosUsuarios() {
        let usuarios = [];
        const querySnapshot = await Firestore.collection('usuarios').get();
        querySnapshot.forEach((doc) => {
          usuarios.push({
            id: doc.id,
            nome: doc.data().nome + ' ' + doc.data().sobrenome,
            email: doc.data().email,
            admin: doc.data().admin,
            desativado: doc.data().desativado || false
          });
        });
        return usuarios;
      },
      async getUsuariosEmpresa() {
        let usuarios = [];

        const empresaDocId = await this.getFirebaseEmpresaDocId();
        const empresaDocRef = await Firestore.collection('empresas').doc(empresaDocId);

        const querySnapshot = await Firestore.collection('usuarios_empresas').where('empresa_id', '==', empresaDocRef).get();

        querySnapshot.forEach(async (doc) => {
          const usuarioId = doc.data().usuario_id.id;
          const usuarioDoc = await Firestore.collection('usuarios').doc(usuarioId).get();

          const { nome, sobrenome, email, admin, desativado } = usuarioDoc.data();
          usuarios.push({
            id: usuarioDoc.id,
            nome: `${nome} ${sobrenome}`,
            email,
            admin,
            desativado: desativado || false
          });
        });

        return usuarios;
      },
      async getFirebaseEmpresaDocId() {
        const empresa = this.$store.getters.getEmpresa;
        const querySnapshot = await Firestore.collection('empresas').where('url', '==', empresa).get();
        return querySnapshot.docs[0]?.id || 0;
      }
    }
  };
</script>
